<template>
  <header>
    <div class="main_header">
      <div class="container">
        <article class="row align-items-center">
          <aside class="col-md-4">
            <div class="left_menu">
              <ul>
                <li>
                  <router-link
                    to="presale"
                    v-if="currentPath !== '/presale' && currentPath !== '/'"
                    >Presale</router-link
                  >
                </li>
                <li>
                  <a href="https://www.ethfighter.com/guide.php" target="_blank"
                    >Characters</a
                  >
                </li>
                <li>
                  <a
                    href="https://www.ethfighter.com/characters.php"
                    target="_blank"
                    >Guides</a
                  >
                </li>
              </ul>
            </div>
          </aside>
          <aside class="col-md-4">
            <div class="logo">
              <a href="https://www.ethfighter.com/" target="_blank"
                ><img src="../assets/images/logo.png" alt="" />
              </a>
            </div>
          </aside>
          <aside class="col-md-4">
            <div class="right_menu">
              <ul>
                <!-- <li><router-link to="presale">Referrals</router-link></li> -->
                <li><a href="#" class="btn_yellow">Play Now Coming Soon</a></li>
              </ul>
            </div>
          </aside>
        </article>
      </div>
    </div>
    <div class="mobile_header">
      <div class="container">
        <article class="row align-items-center">
          <div class="col-md-4 col-sm-6 col-6">
            <div class="logo">
              <a href="index.php"><img src="images/logo.png" alt="" /></a>
            </div>
          </div>
          <div class="col-md-2 col-sm-2 col-2 offset-md-6 offset-sm-4 offset-4">
            <div class="toggleMenu"><i class="fas fa-bars"></i></div>
          </div>
        </article>
        <article class="row toggleNav">
          <aside class="col-md-12">
            <ul>
              <li>
                <router-link
                  to="presale"
                  v-if="currentPath !== '/presale' && currentPath !== '/'"
                  >Presale</router-link
                >
              </li>
              <li>
                <a href="https://www.ethfighter.com/guide.php" target="_blank"
                  >Characters</a
                >
              </li>
              <li>
                <a
                  href="https://www.ethfighter.com/characters.php"
                  target="_blank"
                  >Guides</a
                >
              </li>
              <li><a href="#" class="btn_yellow">Coming Soon</a></li>
            </ul>
          </aside>
        </article>
      </div>
    </div>
  </header>
</template>

<script>
export default {
  name: "Header",
  data() {
    return {
      currentPath: window.location.pathname,
    };
  },
};
</script>

<style scoped>
</style>
